import { WEEK_DAYS } from './constants';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export function getWeekday(dayOfWeek, short = true) {
    return short ? WEEK_DAYS[dayOfWeek].substring(0, 3) : WEEK_DAYS[dayOfWeek];
}
export function formatDate(date) {
    return dayjs.utc(date).format('DD MMM YYYY');
}
export class DateHelper {
    static toMondayWeekDay(day) {
        return (day + 6) % 7;
    }
    static getWeekday(day, short = true) {
        return short ? WEEK_DAYS[day].substring(0, 3) : WEEK_DAYS[day];
    }
    /**
     * Formats an age in years and months from a birth date
     * @param birthDate - The birth date to calculate age from
     * @returns Formatted age string displaying years and months
     */
    static formatAge(birthDate) {
        if (!birthDate) {
            return '-';
        }
        const today = dayjs.utc();
        const birth = dayjs.utc(birthDate);
        const years = today.diff(birth, 'year');
        const months = today.diff(birth.add(years, 'year'), 'month');
        if (years === 0) {
            return `${months} ${months === 1 ? 'month' : 'months'} old`;
        }
        if (months === 0) {
            return `${years} ${years === 1 ? 'year' : 'years'} old`;
        }
        return `${years} ${years === 1 ? 'year' : 'years'}, ${months} ${months === 1 ? 'month' : 'months'} old`;
    }
    /**
     * Formats a date and age from a birth date
     * @param birthDate - The birth date to format
     * @returns Formatted string with date and age
     */
    static formatBirthDateWithAge(birthDate) {
        if (!birthDate) {
            return '-';
        }
        const formattedDate = dayjs.utc(birthDate).format('MMM D, YYYY');
        const age = this.formatAge(birthDate);
        return `${formattedDate} (${age})`;
    }
    static formatTime(time) {
        const [hours, minutes] = time.split(':');
        let date = dayjs.utc();
        date = date.hour(Number(hours));
        date = date.minute(Number(minutes));
        return date.format('h:mm A');
    }
    static toHoursMinutes(time) {
        const [hours, minutes] = time.split(':');
        let date = dayjs.utc();
        date = date.hour(Number(hours));
        date = date.minute(Number(minutes));
        return date.format('HH:mm');
    }
    static timeToDate(time, date) {
        const [hours, minutes] = time.toString().split(':').map(Number);
        const baseDate = date || dayjs.utc();
        return baseDate
            .set('hour', hours)
            .set('minute', minutes)
            .set('second', 0)
            .set('millisecond', 0);
    }
}
